export const blockIconsActivitiesVolunteerActivismNew = (
	<span className='material-symbols-outlined'>volunteer_activism</span>
);
